// removed by extract-text-webpack-plugin
module.exports = {"sizeMD":"16px","Basa":"#EAEBEC","NewGrey":"#596067","attributesLineHeight":"1.8","ScreenLGMin":"(min-width: 1200px)","attributes":"G62dd36"};